import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { IntRangeSelect } from '../../components/controls/IntRangeSelect';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

class RetirementLength extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wantsToPlanUntil: false,
      primaryRetirementAge: props.qna_hash.primaryRetirementAge ? props.qna_hash.primaryRetirementAge.answer : '67',
      partnerRetirementAge: props.qna_hash.partnerRetirementAge ? props.qna_hash.partnerRetirementAge.answer : '67',
      primaryLifeExpectancy: props.qna_hash.primaryLifeExpectancy ? props.qna_hash.primaryLifeExpectancy.answer : '93',
      partnerLifeExpectancy: props.qna_hash.partnerLifeExpectancy ? props.qna_hash.partnerLifeExpectancy.answer : '93',
    };
  }

  componentDidMount() {
    this.props.pathAware('primaryRetirementAge');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.primaryRetirementAge) {
      let mergeState = {
        primaryRetirementAge: props.qna_hash.primaryRetirementAge.answer,
        primaryLifeExpectancy: props.qna_hash.primaryLifeExpectancy.answer,
      };
      if (props.qna_hash.hasPartner.answer) {
        mergeState.partnerRetirementAge = props.qna_hash.partnerRetirementAge.answer;
        mergeState.partnerLifeExpectancy = props.qna_hash.partnerLifeExpectancy.answer;
      }
      this.setState(mergeState);
    }
  }

  toggleWantsToPlanUntil = () => {
    const { wantsToPlanUntil } = this.state;
    this.setState({ wantsToPlanUntil: !wantsToPlanUntil });
  };

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    let frame = {
      primaryRetirementAge: {
        question: 'At what age are you planning to retire?',
        answer: this.state.primaryRetirementAge,
      },
      primaryLifeExpectancy: {
        question: 'Until when do you want to plan?',
        answer: this.state.wantsToPlanUntil ? this.state.primaryLifeExpectancy : '93',
      },
    };

    if (qna_hash.hasPartner.answer) {
      frame.partnerRetirementAge = {
        question: 'At what age is your spouse planning to retire?',
        answer: this.state.partnerRetirementAge,
      };
      frame.partnerLifeExpectancy = {
        question: 'Until when does your spouse want to plan?',
        answer: this.state.wantsToPlanUntil ? this.state.partnerLifeExpectancy : '93',
      };
    }

    this.props.continueOnboarding(qna_stack, qna_hash, frame).then(onContinue);
  };

  _canContinue = () => {
    if (this.props.qna_hash.hasPartner.answer) {
      return this.state.primaryRetirementAge && this.state.partnerRetirementAge;
    } else {
      return this.state.primaryRetirementAge;
    }
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const {
      partnerRetirementAge,
      partnerLifeExpectancy,
      primaryRetirementAge,
      primaryLifeExpectancy,
      wantsToPlanUntil,
    } = this.state;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">At what age are you planning to retire?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text className="mb-0" use="body1">
            If you know what age you'd ideally like to retire at, enter it here. If you're not sure, just enter age 67.
          </Text>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
          <Typography use="body1" style={{ paddingTop: '22px' }}>
            I want to retire at
          </Typography>
          <div className="mr-2" style={{ width: '50px' }}>
            <IntRangeSelect
              id="primaryRetirementAge"
              className="ml-2 mr-2"
              value={primaryRetirementAge}
              onChange={evt => this.onChange(evt, 'primaryRetirementAge')}
              label="Age"
              spec={{
                field_type: 'range',
                min: parseInt(qna_hash.primaryAge.answer) > 50 ? parseInt(qna_hash.primaryAge.answer) : 50,
                max: 85,
                step_size: 1,
                _default: parseInt(qna_hash.primaryAge.answer) > 67 ? parseInt(qna_hash.primaryAge.answer) : 67,
              }}
            />
          </div>

          {wantsToPlanUntil && (
            <Fragment>
              <Typography use="body1" style={{ paddingTop: '22px' }}>
                {' '}
                and plan until{' '}
              </Typography>
              <div style={{ width: '50px' }}>
                <IntRangeSelect
                  id="primaryPlanUntil"
                  className="ml-2 mr-2"
                  value={primaryLifeExpectancy}
                  onChange={evt => this.onChange(evt, 'primaryLifeExpectancy')}
                  label="Age"
                  spec={{
                    field_type: 'integer',
                    min: parseInt(qna_hash.primaryAge.answer),
                    max: 100,
                    _default: 85,
                  }}
                />
              </div>
            </Fragment>
          )}
        </div>
        {qna_hash.hasPartner.answer && (
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Typography use="body1" style={{ paddingTop: '22px' }}>
              My spouse wants to retire at
            </Typography>
            <div className="mr-2" style={{ width: '50px' }}>
              <IntRangeSelect
                id="partnerRetirementAge"
                className="ml-2 mr-2"
                value={partnerRetirementAge}
                onChange={evt => this.onChange(evt, 'partnerRetirementAge')}
                label="Age"
                spec={{
                  field_type: 'range',
                  min: parseInt(qna_hash.partnerAge.answer) > 50 ? parseInt(qna_hash.partnerAge.answer) : 50,
                  max: 85,
                  step_size: 1,
                  _default: parseInt(qna_hash.partnerAge.answer) > 67 ? parseInt(qna_hash.partnerAge.answer) : 67,
                }}
              />
            </div>

            {wantsToPlanUntil && (
              <Fragment>
                <Typography use="body1" style={{ paddingTop: '22px' }}>
                  {' '}
                  and plan until{' '}
                </Typography>
                <div style={{ width: '50px' }}>
                  <IntRangeSelect
                    id="partnerPlanUntil"
                    className="ml-2 mr-2"
                    value={partnerLifeExpectancy}
                    onChange={evt => this.onChange(evt, 'partnerLifeExpectancy')}
                    label="Age"
                    spec={{
                      field_type: 'integer',
                      min: parseInt(qna_hash.partnerAge.answer),
                      max: 100,
                      _default: 85,
                    }}
                  />
                </div>
              </Fragment>
            )}
          </div>
        )}
        {wantsToPlanUntil ? (
          <Button theme="secondary" onClick={this.toggleWantsToPlanUntil} className="mt-4">
            I don't know how long to plan for
          </Button>
        ) : (
          <Text use="body1" className="mt-4">
            {'If you think you know how long to plan for, click '}
            <span style={{ cursor: 'pointer' }}>
              <a onClick={this.toggleWantsToPlanUntil}>here</a>
            </span>
          </Text>
        )}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(RetirementLength);
